import clsx from 'clsx';
import { ComponentProps, PropsWithChildren } from 'react';
import { Button as CommonButton } from './Button';
import { ButtonDiv as CommonButtonDiv } from './ButtonDiv';
import { ButtonIcon as CommonButtonIcon } from './ButtonIcon';

function Root({ children }: PropsWithChildren) {
  return <div className="flex items-center">{children}</div>;
}

type ButtonProps = Omit<ComponentProps<typeof CommonButton>, 'variant' | 'size'>;

function Button({ className, ...rest }: ButtonProps) {
  return (
    <CommonButton variant="secondary" size="lg" className={clsx('rounded-none hover:z-10', className)} {...rest} />
  );
}

type ButtonIconProps = Omit<ComponentProps<typeof CommonButtonIcon>, 'variant' | 'size'>;

function ButtonIcon({ className, ...rest }: ButtonIconProps) {
  return (
    <CommonButtonIcon variant="secondary" size="lg" className={clsx('rounded-none hover:z-10', className)} {...rest} />
  );
}

type ButtonDivProps = Omit<ComponentProps<typeof CommonButtonDiv>, 'variant' | 'size'>;

function ButtonDiv({ className, ...rest }: ButtonDivProps) {
  return (
    <CommonButtonDiv variant="secondary" size="lg" className={clsx('rounded-none hover:z-10', className)} {...rest} />
  );
}

const Item = {
  Button,
  ButtonDiv,
  ButtonIcon,
};

export const ButtonGroup = {
  Root,
  Item,
};
